var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "flex-vertical photo-container" }, [
        _vm.shownImage
          ? _c("input", {
              staticClass: "fill-space",
              attrs: {
                type: "image",
                src: _vm.getPhotoWithBase64(_vm.shownImage),
                alt: _vm.label
              },
              on: { click: _vm.openImageDialog }
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.shownImage
          ? _c(
              "div",
              { staticClass: "flex-vertical photo-options" },
              [
                _c("MenuButton", {
                  staticClass: "photo-options-button",
                  on: {
                    click: function($event) {
                      _vm.hoverMenu = !_vm.hoverMenu
                    }
                  }
                }),
                _vm._v(" "),
                _c("photo-menu", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.hoverMenu,
                      expression: "hoverMenu"
                    }
                  ],
                  on: {
                    updateImage: _vm.onFileChange,
                    removeImage: _vm.removeImage
                  }
                })
              ],
              1
            )
          : _c(
              "div",
              {
                staticClass: "input-photo fill-space",
                class: { disabled: _vm.disabled },
                style: { "background-image": "url(" + _vm.photoIcon + ")" },
                on: { change: _vm.onFileChange }
              },
              [
                _c("input", {
                  staticClass: "photo-input fill-space",
                  attrs: {
                    type: "file",
                    accept: "image/*",
                    title: "",
                    disabled: _vm.disabled
                  }
                })
              ]
            )
      ]),
      _vm._v(" "),
      _vm.imageDialog
        ? _c("photo-opened", {
            attrs: {
              imageData: _vm.imageData,
              image: _vm.value.image,
              thumb: _vm.value.image_thumb,
              description: _vm.value.description,
              uuid: _vm.value.uuid,
              disabled: _vm.disabled
            },
            on: {
              removeImage: _vm.removeImage,
              close: _vm.closeImageDialog,
              updateDescription: _vm.updateDescription
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("photo-upload-error", {
        attrs: {
          toggleDialog: _vm.uploadErrorDialog,
          specificErrorMessage: _vm.$t(_vm.specificErrorMessage)
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c355361c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c355361c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_Atoms/InputTypes/InputTypePhoto.vue
// module id = null
// module chunks = 